const translations = {
  en: {
    signupTitle: "Create your account",
    loginTitle: "Login to your account",
    forgotPassword: "Forgot password?",
    haveAccount: "Already have an account?",
    signupSuccess: "Signup successful! Please login.",
    emailInUse: "This email is already registered. Please login instead.",
    weakPassword: "Password should be at least 6 characters.",
    selectLanguage: "Select Your Preferred Language",
    signup: "Sign Up",
    login: "Login",
    email: "Email",
    password: "Password",
    emailPlaceholder: "Enter your email",
    passwordPlaceholder: "Enter your password",
  loginButton: "Login",
  chooseFiles: "Choose Files",
    loggingIn: "Logging in...",
    noAccount: "Don't have an account?",
    continueWithGoogle: "Continue with Google",
    loginFailed: "❌ Login failed",
    name: "Name",
    age: "Age",
    gender: "Gender",
    genderMale: "Male",
    genderFemale: "Female",
    genderOther: "Other",
    profession: "Profession",
    professionBeautyParlour: "Beauty Parlour",
    professionTailoring: "Tailoring",
    professionInteriorDesign: "Interior Design",
    professionPhotography: "Photography",
    professionPainting: "Painting",
    professionCarpentering: "Carpentering",
    professionOther: "Other",
    location: "Filters",
    experience: "Experience (in years)",
    phone: "Phone Number: ",
    submit: "Submit",
    welcome: "Welcome to SkillRise",
    likes: "Likes",
    rate: "Rate",
    message: "Message",
    noPosts: "No posts or videos available.",
    upload: "Upload",
    logout: "Logout",
    uploadVideo: "Upload Skill Video (max 60s)",
    uploading: "Uploading...",
    createProfile: "Create Profile",
    profileCreated: "Profile created successfully!",
  editProfile: "Edit Profile",
  logout: "Logout",
  phone: "Phone Number: ",
  genderMale: "Male",
  genderFemale: "Female",
  genderOther: "Other",
  profession: "Profession",
  experience: "Experience (in years)",
  createProfile: "Create Profile",
  name: "Name",
  needsAroundYou: "Needs Around You",
  searchLocation: "Filters",
  loadingProfile: "Loading profile...",
    chat: "Chat",
    send: "Send",
    typeMessage: "Type a message...",
    startRecording: "🎙 Start Recording",
    stopRecording: "⏹ Stop Recording",
    places: [
      "Bhimavaram", "Palakollu", "Tanuku", "Tadepalligudem",
      "Eluru", "Jangareddygudem", "Narasapuram", "Kovvur",
      "Rajahmundry", "Kakinada", "Samalkot", "Pithapuram",
      "Tuni", "Annavaram", "Amalapuram", "Mummidivaram"
    ]
  },

  hi: {
    editProfile: "प्रोफ़ाइल संपादित करें",
    logout: "लॉग आउट",
    phone: "फ़ोन नंबर: ",
    genderMale: "पुरुष",
    genderFemale: "महिला",
    genderOther: "अन्य",
    profession: "पेशा",
    experience: "अनुभव (वर्षों में)",
    createProfile: "प्रोफ़ाइल बनाएं",
    name: "नाम",
  signupTitle: "अपना खाता बनाएं",
  loginTitle: "अपने खाते में लॉगिन करें",
  forgotPassword: "पासवर्ड भूल गए?",
  haveAccount: "पहले से खाता है?",
  signupSuccess: "साइनअप सफल! कृपया लॉगिन करें।",
  emailInUse: "यह ईमेल पहले से पंजीकृत है। कृपया लॉगिन करें।",
  weakPassword: "पासवर्ड कम से कम 6 अक्षर का होना चाहिए।",
    selectLanguage: "अपनी पसंदीदा भाषा चुनें",
    signup: "साइन अप",
    login: "लॉगिन",
    email: "ईमेल",
    password: "पासवर्ड",
    emailPlaceholder: "अपना ईमेल दर्ज करें",
    passwordPlaceholder: "अपना पासवर्ड दर्ज करें",
  loginButton: "लॉगिन",
  chooseFiles: "एकाधिक फ़ाइलें चुनें",
    loggingIn: "लॉगिन हो रहा है...",
    noAccount: "खाता नहीं है?",
    continueWithGoogle: "Google से जारी रखें",
    loginFailed: "❌ लॉगिन असफल",
    name: "नाम",
    age: "आयु",
    gender: "लिंग",
    genderMale: "पुरुष",
    genderFemale: "महिला",
    genderOther: "अन्य",
    profession: "पेशा",
    professionBeautyParlour: "ब्यूटी पार्लर",
    professionTailoring: "सिलाई",
    professionInteriorDesign: "इंटीरियर डिजाइन",
    professionPhotography: "फोटोग्राफी",
    professionPainting: "पेंटिंग",
    professionCarpentering: "बढ़ईगिरी",
    professionOther: "अन्य",
    location: "फ़िल्टर",
    experience: "अनुभव (वर्षों में)",
    phone: "फ़ोन नंबर: ",
    submit: "जमा करें",
    welcome: "स्किलराइज़ में आपका स्वागत है",
    likes: "लाइक्स",
    rate: "रेट करें",
    message: "संदेश",
    noPosts: "कोई पोस्ट या वीडियो उपलब्ध नहीं है।",
    upload: "अपलोड करें",
    logout: "लॉग आउट",
    uploadVideo: "स्किल वीडियो अपलोड करें (60 सेकंड तक)",
    uploading: "अपलोड हो रहा है...",
    createProfile: "प्रोफ़ाइल बनाएं",
    profileCreated: "प्रोफ़ाइल सफलतापूर्वक बनाई गई!",
    editProfile: "प्रोफ़ाइल संपादित करें",
    needsAroundYou: "आपके आसपास की आवश्यकताएँ",
    searchLocation: "फ़िल्टर",
    loadingProfile: "प्रोफ़ाइल लोड हो रही है...",
    chat: "चैट",
    send: "भेजें",
    typeMessage: "संदेश लिखें...",
    startRecording: "🎙 रिकॉर्डिंग शुरू करें",
    stopRecording: "⏹ रिकॉर्डिंग रोकें",
    places: [
      "भीमावरम","पलकोल्लु","तानुकु","तडेपल्लीगुडेम",
      "एलुरु","जंगारेड्डीगुडेम","नरसापुरम","कोव्वूर",
      "राजमहेंद्रवरम","काकीनाडा","समालकोट","पिथापुरम",
      "टूनी","अन्नवरम","अमलापुरम","मुम्मिदीवरम"
    ]
  },

  te: {
    editProfile: "ప్రొఫైల్ సవరించండి",
    logout: "లాగౌట్",
    phone: "ఫోన్ నంబర్: ",
    genderMale: "పురుషుడు",
    genderFemale: "మహిళ",
    genderOther: "ఇతరులు",
    profession: "వృత్తి",
    experience: "అనుభవం (సంవత్సరాల్లో)",
    createProfile: "ప్రొఫైల్ సృష్టించండి",
    name: "పేరు",
  signupTitle: "మీ ఖాతాను సృష్టించండి",
  loginTitle: "మీ ఖాతాలో లాగిన్ అవ్వండి",
  forgotPassword: "పాస్వర్డ్ మర్చిపోయారా?",
  haveAccount: "ఇప్పటికే ఖాతా ఉందా?",
  signupSuccess: "సైన్ అప్ విజయవంతం! దయచేసి లాగిన్ అవ్వండి.",
  emailInUse: "ఈ ఇమెయిల్ ఇప్పటికే నమోదు అయింది. దయచేసి లాగిన్ చేయండి.",
  weakPassword: "పాస్వర్డ్ కనీసం 6 అక్షరాలు ఉండాలి.",
    selectLanguage: "మీకు ఇష్టమైన భాషను ఎంచుకోండి",
    signup: "సైన్ అప్",
    login: "లాగిన్",
    email: "ఈమెయిల్",
    password: "పాస్వర్డ్",
    emailPlaceholder: "మీ ఈమెయిల్ నమోదు చేయండి",
    passwordPlaceholder: "మీ పాస్వర్డ్ నమోదు చేయండి",
  loginButton: "లాగిన్",
  chooseFiles: "ఫైళ్ళను ఎంచుకోండి",
    loggingIn: "లాగిన్ అవుతోంది...",
    noAccount: "ఖాతా లేదా?",
    continueWithGoogle: "Google తో కొనసాగించండి",
    loginFailed: "❌ లాగిన్ విఫలమైంది",
    name: "పేరు",
    age: "వయస్సు",
    gender: "లింగం",
    genderMale: "పురుషుడు",
    genderFemale: "మహిళ",
    genderOther: "ఇతరులు",
    profession: "వృత్తి",
    professionBeautyParlour: "బ్యూటీ పార్లర్",
    professionTailoring: "దర్జీ పని",
    professionInteriorDesign: "ఇంటీరియర్ డిజైన్",
    professionPhotography: "ఫోటోగ్రఫీ",
    professionPainting: "పెయింటింగ్",
    professionCarpentering: "కార్పెంటరీ",
    professionOther: "ఇతరులు",
    location: "ఫిల్టర్లు",
    experience: "అనుభవం (సంవత్సరాల్లో)",
    phone: "ఫోన్ నంబర్: ",
    submit: "సబ్మిట్",
    welcome: "స్కిల్‌రైజ్‌కి స్వాగతం",
    likes: "లైక్స్",
    rate: "రేట్ చేయండి",
    message: "మెసేజ్",
    noPosts: "పోస్ట్‌లు లేదా వీడియోలు లభించలేదు.",
    upload: "అప్లోడ్ చేయండి",
    logout: "లాగౌట్",
    uploadVideo: "నైపుణ్య వీడియోను అప్లోడ్ చేయండి (60సెకలు)",
    uploading: "అప్లోడ్ అవుతోంది...",
    createProfile: "ప్రొఫైల్ సృష్టించండి",
    profileCreated: "ప్రొఫైల్ విజయవంతంగా సృష్టించబడింది!",
    editProfile: "ప్రొఫైల్ సవరించండి",
    needsAroundYou: "మీ చుట్టూ అవసరాలు",
    searchLocation: "ఫిల్టర్లు",
    loadingProfile: "ప్రొఫైల్ లోడ్ అవుతోంది...",
    chat: "చాట్",
    send: "పంపండి",
    typeMessage: "సందేశాన్ని టైప్ చేయండి...",
    startRecording: "🎙 రికార్డింగ్ ప్రారంభించండి",
    stopRecording: "⏹ రికార్డింగ్ ఆపండి",
    places: [
      "భీమవరం", "పాలకొల్లు", "తనుకు", "తాడేపల్లి గూడెం",
      "ఎలూరు", "జంగారెడ్డి గూడెం", "నరసాపురం", "కోవ్వూరు",
      "రాజమండ్రి", "కాకినాడ", "సామల్కోట్", "పిఠాపురం",
      "తుని", "అన్నవరం", "అమలాపురం", "ముమ్మిడివరం"
    ]
  },

  kn: {
    editProfile: "ಪ್ರೊಫೈಲ್ ಸಂಪಾದಿಸಿ",
    logout: "ಲಾಗ್‌ಔಟ್",
    phone: "ಫೋನ್ ನಂಬರ್: ",
    genderMale: "ಪುರುಷ",
    genderFemale: "ಸ್ತ್ರೀ",
    genderOther: "ಇತರೆ",
    profession: "ವೃತ್ತಿ",
    experience: "ಅನುಭವ (ವರ್ಷಗಳಲ್ಲಿ)",
    createProfile: "ಪ್ರೊಫೈಲ್ ರಚಿಸಿ",
    name: "ಹೆಸರು",
    selectLanguage: "ನಿಮ್ಮ ಇಷ್ಟದ ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    signup: "ಸೈನ್ ಅಪ್",
    login: "ಲಾಗಿನ್",
    email: "ಇಮೇಲ್",
    password: "ಪಾಸ್‌ವರ್ಡ್",
    emailPlaceholder: "ನಿಮ್ಮ ಇಮೇಲ್ ನಮೂದಿಸಿ",
    passwordPlaceholder: "ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್ ನಮೂದಿಸಿ",
  loginButton: "ಲಾಗಿನ್",
  chooseFiles: "ಹಲವಾರು ಫೈಲ್‌ಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    loggingIn: "ಲಾಗಿನ್ ಆಗುತ್ತಿದೆ...",
    noAccount: "ಖಾತೆ ಇಲ್ಲವೇ?",
    continueWithGoogle: "Google ಮೂಲಕ ಮುಂದುವರಿಸಿ",
    loginFailed: "❌ ಲಾಗಿನ್ ವಿಫಲವಾಗಿದೆ",
    name: "ಹೆಸರು",
    age: "ವಯಸ್ಸು",
    gender: "ಲಿಂಗ",
    genderMale: "ಪುರುಷ",
    genderFemale: "ಸ್ತ್ರೀ",
    genderOther: "ಇತರೆ",
    profession: "ವೃತ್ತಿ",
    professionBeautyParlour: "ಬ್ಯೂಟಿ ಪಾರ್ಲರ್",
    professionTailoring: "ದರ್ಜೀ ಕೆಲಸ",
    professionInteriorDesign: "ಆಂತರಿಕ ವಿನ್ಯಾಸ",
    professionPhotography: "ಫೋಟೋಗ್ರಫಿ",
    professionPainting: "ಚಿತ್ರಕಲೆ",
    professionCarpentering: "ದರ್ಗಾ ಕೆಲಸ",
    professionOther: "ಇತರೆ",
    location: "ಫಿಲ್ಟರ್‌ಗಳು",
    experience: "ಅನುಭವ (ವರ್ಷಗಳಲ್ಲಿ)",
    phone: "ಫೋನ್ ನಂಬರ್: ",
    submit: "ಸಲ್ಲಿಸು",
    welcome: "ಸ್ಕಿಲ್‌ರೈಸ್‌ಗೆ ಸ್ವಾಗತ",
    likes: "ಲೈಕ್ಸ್",
    rate: "ರೇಟ್ ಮಾಡಿ",
    message: "ಸಂದೇಶ",
    noPosts: "ಯಾವುದೇ ಪೋಸ್ಟ್ ಅಥವಾ ವೀಡಿಯೊ ಲಭ್ಯವಿಲ್ಲ.",
    upload: "ಅಪ್ಲೋಡ್ ಮಾಡಿ",
    logout: "ಲಾಗ್‌ಔಟ್",
    uploadVideo: "ಕೌಶಲ್ಯ ವೀಡಿಯೊ ಅಪ್ಲೋಡ್ ಮಾಡಿ (ಗರಿಷ್ಠ 60 ಸೆಕೆಂಡುಗಳು)",
    uploading: "ಅಪ್ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
    createProfile: "ಪ್ರೊಫೈಲ್ ರಚಿಸಿ",
    profileCreated: "ಪ್ರೊಫೈಲ್ ಯಶಸ್ವಿಯಾಗಿ ರಚಿಸಲಾಗಿದೆ!",
    editProfile: "ಪ್ರೊಫೈಲ್ ಸಂಪಾದಿಸಿ",
    needsAroundYou: "ನಿಮ್ಮ ಸುತ್ತಲಿನ ಅಗತ್ಯಗಳು",
    searchLocation: "ಫಿಲ್ಟರ್‌ಗಳು",
    loadingProfile: "ಪ್ರೊಫೈಲ್ ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
    chat: "ಚಾಟ್",
    send: "ಕಳುಹಿಸಿ",
    typeMessage: "ಸಂದೇಶವನ್ನು ಟೈಪ್ ಮಾಡಿ...",
    startRecording: "🎙 ರೆಕಾರ್ಡಿಂಗ್ ಪ್ರಾರಂಭಿಸಿ",
    stopRecording: "⏹ ರೆಕಾರ್ಡಿಂಗ್ ನಿಲ್ಲಿಸಿ",
    places: [
      "ಭೀಮವರಂ", "ಪಾಲಕೊಲ್ಲು", "ತನೂಕು", "ತಾಡೆಪಲ್ಲಿ ಗುಡೇಮ್",
      "ಎಲೂರು", "ಜಂಗಾರೆಡ್ಡಿ ಗುಡೇಮ್", "ನರಸಾಪುರಂ", "ಕೋವ್ವೂರು",
      "ರಾಜಮಹೇಂದ್ರಿ", "ಕಾಕಿನಾಡ", "ಸಾಮಲ್ಕೋಟ್", "ಪಿಠಾಪುರಂ",
      "ತುನಿ", "ಅನ್ನಾವರಂ", "ಅಮಲಾಪುರಂ", "ಮುಂಬಿಡಿವರಂ"
    ]
  },

  ml: {
    editProfile: "പ്രൊഫൈൽ തിരുത്തുക",
    logout: "ലോഗ് ഔട്ട്",
    phone: "ഫോൺ നമ്പർ: ",
    genderMale: "പുരുഷൻ",
    genderFemale: "സ്ത്രീ",
    genderOther: "മറ്റ്",
    profession: "തൊഴിൽ",
    experience: "പരിചയം (വർഷങ്ങളിൽ)",
    createProfile: "പ്രൊഫൈൽ സൃഷ്ടിക്കുക",
    name: "പേര്",
    selectLanguage: "നിങ്ങളുടെ ഇഷ്ട ഭാഷ തിരഞ്ഞെടുക്കുക",
    signup: "സൈൻ അപ്പ്",
    login: "ലോഗിൻ",
    email: "ഇമെയിൽ",
    password: "പാസ്‌വേഡ്",
    emailPlaceholder: "നിങ്ങളുടെ ഇമെയിൽ നൽകുക",
    passwordPlaceholder: "നിങ്ങളുടെ പാസ്‌വേഡ് നൽകുക",
  loginButton: "ലോഗിൻ",
  chooseFiles: "ഫയലുകൾ തിരഞ്ഞെടുക്കുക",
    loggingIn: "ലോഗിൻ ചെയ്യുന്നു...",
    noAccount: "അക്കൗണ്ട് ഇല്ലേ?",
    continueWithGoogle: "Google ഉപയോഗിച്ച് തുടരുക",
    loginFailed: "❌ ലോഗിൻ പരാജയപ്പെട്ടു",
    name: "പേര്",
    age: "വയസ്സ്",
    gender: "ലിംഗം",
    genderMale: "പുരുഷൻ",
    genderFemale: "സ്ത്രീ",
    genderOther: "മറ്റ്",
    profession: "തൊഴിൽ",
    professionBeautyParlour: "ബ്യൂട്ടി പാർലർ",
    professionTailoring: "തയ്യൽ",
    professionInteriorDesign: "ഇന്റീരിയർ ഡിസൈൻ",
    professionPhotography: "ഫോട്ടോഗ്രാഫി",
    professionPainting: "ചിത്രരചന",
    professionCarpentering: "വുഡ് വർക്ക്",
    professionOther: "മറ്റ്",
    location: "ഫിൽറ്ററുകൾ",
    experience: "പരിചയം (വർഷങ്ങളിൽ)",
    phone: "ഫോൺ നമ്പർ: ",
    submit: "സമർപ്പിക്കുക",
    welcome: "സ്കിൽറൈസിലേക്ക് സ്വാഗതം",
    likes: "ലൈക്കുകൾ",
    rate: "റേറ്റ് ചെയ്യുക",
    message: "സന്ദേശം",
    noPosts: "പോസ്റ്റുകൾ അല്ലെങ്കിൽ വീഡിയോകൾ ലഭ്യമല്ല.",
    upload: "അപ്‌ലോഡ് ചെയ്യുക",
    logout: "ലോഗ് ഔട്ട്",
    uploadVideo: "സ്കിൽ വീഡിയോ അപ്‌ലോഡ് ചെയ്യുക (60 സെക്കൻഡ് വരെ)",
    uploading: "അപ്‌ലോഡ് ചെയ്യുന്നു...",
    createProfile: "പ്രൊഫൈൽ സൃഷ്ടിക്കുക",
    profileCreated: "പ്രൊഫൈൽ വിജയകരമായി സൃഷ്ടിച്ചു!",
    editProfile: "പ്രൊഫൈൽ തിരുത്തുക",
    needsAroundYou: "നിങ്ങളുടെ ചുറ്റുമുള്ള ആവശ്യങ്ങൾ",
    searchLocation: "ഫിൽറ്ററുകൾ",
    loadingProfile: "പ്രൊഫൈൽ ലോഡ് ചെയ്യുന്നു...",
    chat: "ചാറ്റ്",
    send: "അയയ്ക്കുക",
    typeMessage: "സന്ദേശം ടൈപ്പ് ചെയ്യുക...",
    startRecording: "🎙 റെക്കോർഡിംഗ് ആരംഭിക്കുക",
    stopRecording: "⏹ റെക്കോർഡിംഗ് നിർത്തുക",
    places: [
      "ഭീമവരം", "പാലകൊല്ലു", "തനുകു", "താഡെപല്ലിഗുഡേം",
      "എലുരു", "ജംഗറെഡ്ഡിഗുഡേം", "നരസാപുരം", "കോവ്വൂർ",
      "രാജമഹേന്ദ്രവരം", "കാക്കിനാഡ", "സാമൽകോട്ട്", "പിഠാപുരം",
      "തുനി", "അന്നാവരം", "അമലാപുരം", "മുമ്മിഡിവരം"
    ]
  },

  ta: {
    editProfile: "சுயவிவரம் திருத்தவும்",
    logout: "வெளியேறு",
    phone: "தொலைபேசி எண்: ",
    genderMale: "ஆண்",
    genderFemale: "பெண்",
    genderOther: "மற்றவை",
    profession: "தொழில்",
    experience: "அனுபவம் (ஆண்டுகளில்)",
    createProfile: "சுயவிவரம் உருவாக்கவும்",
    name: "பெயர்",
  signupTitle: "உங்கள் கணக்கை உருவாக்கவும்",
  loginTitle: "உங்கள் கணக்கில் உள்நுழையவும்",
  forgotPassword: "கடவுச்சொல்லை மறந்துவிட்டீர்களா?",
  haveAccount: "ஏற்கனவே கணக்கு உள்ளதா?",
  signupSuccess: "பதிவு வெற்றிகரமாக முடிந்தது! தயவுசெய்து உள்நுழையவும்.",
  emailInUse: "இந்த மின்னஞ்சல் ஏற்கனவே பதிவு செய்யப்பட்டுள்ளது. தயவுசெய்து உள்நுழையவும்.",
  weakPassword: "கடவுச்சொல் குறைந்தது 6 எழுத்துகள் இருக்க வேண்டும்.",
    selectLanguage: "உங்களுக்கு விருப்பமான மொழியைத் தேர்ந்தெடுக்கவும்",
    signup: "பதிவு செய்யவும்",
    login: "உள்நுழையவும்",
    email: "மின்னஞ்சல்",
    password: "கடவுச்சொல்",
    emailPlaceholder: "உங்கள் மின்னஞ்சலை உள்ளிடவும்",
    passwordPlaceholder: "உங்கள் கடவுச்சொல்லை உள்ளிடவும்",
  loginButton: "உள்நுழைய",
  chooseFiles: "பல கோப்புகளைத் தேர்ந்தெடுக்கவும்",
    loggingIn: "உள்நுழைகிறது...",
    noAccount: "கணக்கு இல்லையா?",
    continueWithGoogle: "Google மூலம் தொடரவும்",
    loginFailed: "❌ உள்நுழைவு தோல்வியடைந்தது",
    name: "பெயர்",
    age: "வயது",
    gender: "பாலினம்",
    genderMale: "ஆண்",
    genderFemale: "பெண்",
    genderOther: "மற்றவை",
    profession: "தொழில்",
    professionBeautyParlour: "அழகு நிலையம்",
    professionTailoring: "தையல்",
    professionInteriorDesign: "உள் வடிவமைப்பு",
    professionPhotography: "புகைப்படக்கலை",
    professionPainting: "ஓவியம்",
    professionCarpentering: "தச்சு வேலை",
    professionOther: "மற்றவை",
    location: "வடிகட்டிகள்",
    experience: "அனுபவம் (ஆண்டுகளில்)",
    phone: "தொலைபேசி எண்: ",
    submit: "சமர்ப்பிக்கவும்",
    welcome: "ஸ்கில் ரைஸுக்கு வரவேற்கிறோம்",
    likes: "விருப்பங்கள்",
    rate: "மதிப்பிடு",
    message: "செய்தி",
    noPosts: "பதிவுகள் அல்லது வீடியோக்கள் இல்லை.",
    upload: "பதிவேற்று",
    logout: "வெளியேறு",
    uploadVideo: "திறன் வீடியோ பதிவேற்றவும் (அதிகபட்சம் 60வினாடிகள்)",
    uploading: "பதிவேற்றப்படுகிறது...",
    createProfile: "சுயவிவரம் உருவாக்கவும்",
    profileCreated: "சுயவிவரம் வெற்றிகரமாக உருவாக்கப்பட்டது!",
    editProfile: "சுயவிவரம் திருத்தவும்",
    needsAroundYou: "உங்களைச் சுற்றியுள்ள தேவைகள்",
    searchLocation: "வடிகட்டிகள்",
    loadingProfile: "சுயவிவரம் ஏற்றுகிறது...",
    chat: "அரட்டை",
    send: "அனுப்பு",
     typeMessage: "செய்தியை Type செய்யவும்...",
    startRecording: "🎙 பதிவு தொடங்கவும்",
    stopRecording: "⏹ பதிவை நிறுத்தவும்",
    openTo: "திறந்தது",
    addSection: "பிரிவைச் சேர்க்கவும்",
    enhanceProfile: "சுயவிவரத்தை மேம்படுத்தவும்",
    places: [
      "பீமவரம்", "பாலகொல்லு", "தனுகு", "தாடேபலிகுடேம்",
      "எலுரு", "ஜங்காரெட்டிகுடேம்", "நரசாபுரம்", "கோவ்வூர்",
      "ராஜமகேந்திரம்", "காகிநாட", "சாமல்கோட்", "பிடாபுரம்",
      "துனி", "அன்னவரம்", "அமலாபுரம்", "மும்மிடிவரம்"
    ]

  },

  bn: {
    editProfile: "প্রোফাইল সম্পাদনা করুন",
    logout: "লগআউট",
    phone: "ফোন নম্বর: ",
    genderMale: "পুরুষ",
    genderFemale: "মহিলা",
    genderOther: "অন্যান্য",
    profession: "পেশা",
    experience: "অভিজ্ঞতা (বছরে)",
    createProfile: "প্রোফাইল তৈরি করুন",
    name: "নাম",
  signupTitle: "আপনার অ্যাকাউন্ট তৈরি করুন",
  loginTitle: "আপনার অ্যাকাউন্টে লগইন করুন",
  forgotPassword: "পাসওয়ার্ড ভুলে গেছেন?",
  haveAccount: "ইতিমধ্যে অ্যাকাউন্ট আছে?",
  signupSuccess: "সাইন আপ সফল! দয়া করে লগইন করুন।",
  emailInUse: "এই ইমেলটি ইতিমধ্যে নিবন্ধিত। দয়া করে লগইন করুন।",
  weakPassword: "পাসওয়ার্ড কমপক্ষে ৬ অক্ষরের হতে হবে।",
  signupTitle: "तुमचे खाते तयार करा",
  loginTitle: "तुमच्या खात्यात लॉगिन करा",
  forgotPassword: "पासवर्ड विसरलात का?",
  haveAccount: "आधीच खाते आहे?",
  signupSuccess: "साइनअप यशस्वी! कृपया लॉगिन करा.",
  emailInUse: "हे ईमेल आधीच नोंदणीकृत आहे. कृपया लॉगिन करा.",
  weakPassword: "पासवर्ड किमान 6 अक्षरे असावा.",
    selectLanguage: "আপনার পছন্দের ভাষা নির্বাচন করুন",
    signup: "সাইন আপ",
    login: "লগইন",
    email: "ইমেল",
    password: "পাসওয়ার্ড",
    emailPlaceholder: "আপনার ইমেল লিখুন",
    passwordPlaceholder: "আপনার পাসওয়ার্ড লিখুন",
  loginButton: "লগইন",
  chooseFiles: "একাধিক ফাইল নির্বাচন করুন",
    loggingIn: "লগইন হচ্ছে...",
    noAccount: "অ্যাকাউন্ট নেই?",
    continueWithGoogle: "Google দিয়ে চালিয়ে যান",
    loginFailed: "❌ লগইন ব্যর্থ হয়েছে",
    name: "নাম",
    age: "বয়স",
    gender: "লিঙ্গ",
    genderMale: "পুরুষ",
    genderFemale: "মহিলা",
    genderOther: "অন্যান্য",
    profession: "পেশা",
    professionBeautyParlour: "বিউটি পার্লার",
    professionTailoring: "দর্জির কাজ",
    professionInteriorDesign: "ইন্টেরিয়র ডিজাইন",
    professionPhotography: "ফটোগ্রাফি",
    professionPainting: "পেইন্টিং",
    professionCarpentering: "কারিগরি",
    professionOther: "অন্যান্য",
    location: "অবস্থান",
    experience: "অভিজ্ঞতা (বছরে)",
    phone: "ফোন নম্বর: ",
    submit: "জমা দিন",
    welcome: "স্কিলরাইজ-এ স্বাগতম",
    likes: "লাইক",
    rate: "রেট করুন",
    message: "বার্তা",
    noPosts: "কোনও পোস্ট বা ভিডিও নেই।",
    upload: "আপলোড করুন",
    logout: "লগআউট",
    uploadVideo: "দক্ষতার ভিডিও আপলোড করুন (৬০সেকেন্ড পর্যন্ত)",
    uploading: "আপলোড হচ্ছে...",
    createProfile: "প্রোফাইল তৈরি করুন",
    profileCreated: "প্রোফাইল সফলভাবে তৈরি হয়েছে!",
    editProfile: "প্রোফাইল সম্পাদনা করুন",
    needsAroundYou: "আপনার চারপাশের প্রয়োজনীয়তা",
    searchLocation: "ফিল্টার",
    loadingProfile: "প্রোফাইল লোড হচ্ছে...",
    chat: "চ্যাট",
    send: "পাঠান",
    typeMessage: "বার্তা টাইপ করুন...",
    startRecording: "🎙 রেকর্ডিং শুরু করুন",
    stopRecording: "⏹ রেকর্ডিং বন্ধ করুন",
    openTo: "খোলা আছে",
    addSection: "সেকশন যোগ করুন",
    enhanceProfile: "প্রোফাইল উন্নত করুন",
    places: [
      "ভীমভারম", "পালাকোল্লু", "তানুকু", "তাড়েপাল্লিগুডেম",
      "এলুরু", "জঙ্গারেড্ডিগুডেম", "নারাসাপুরম", "কোভ্ভুর",
      "রাজামাহেন্দ্রভরম", "কাকিনাডা", "সামালকোট", "পিঠাপুরম",
      "তুনি", "আন্নভারম", "অমলাপুরম", "মুম্মিডিভারম"
    ]

  },
};

export default translations;
